var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn fa",on:{"click":_vm.userSignIn}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":this.icon,"size":this.size}}),_vm._v(" "+_vm._s(_vm.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }